<template>
  <panel>
    <div slot="toolbar" class="p-3">
      <w-datepicker class="d-inline-block mr-5" :model="$schema.modified.$gte" />

      <w-datepicker class="d-inline-block mr-5" :model="$schema.modified.$lte" />

      <yes-or-no-radio class="d-inline-block mr-5" :model="$schema.isUkraine" />

      <w-button class="btn-primary mb-1 mr-1" text="Filtruj" icon="fa fa-search" @click="applyFilters" />

      <w-button class="btn-secondary mb-1 mr-1" text="Wyczyść" icon="fa fa-times" @click="clearFilters" />

      <post-form button-class="btn-secondary ml-5 mb-1" text="Pobierz CSV" :url="csvUrl" :fields="csvFields" />
    </div>

    <w-table
      :data="list"
      :columns="columns"
      :total="list.length"
      :hide-search-input="true"
      :hide-add-button="true"
      :per-page="-1"
    />
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import YesOrNoRadio from '@/components/forms/document/YesOrNoRadio.vue';
import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm.vue';
import WTable from '@/components/table/Table';
import { Errors } from '@/enums/errors.enum';
import { Storage } from '@/enums/storage.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/reportDecisions.schema';
import { config } from '@/utils/config';
import { getDecisionReport } from '@/utils/decisionReport';
import { parseJsonOrDefault } from '@/utils/parseJsonOrDefault';
import { removeEmptyObjectFields } from '@/utils/removeEmptyFields';

// @vuese
// Raport decyzji
// @group Reports
export default {
  components: { Panel, PostForm, WTable, YesOrNoRadio },
  mixins: [formMixin, notificationsMixin],

  schema,

  data() {
    const filtersJson = sessionStorage.getItem(Storage.REPORT_DECISION_FILTERS);
    const filters = parseJsonOrDefault(filtersJson, {});
    return { model: filters };
  },
  computed: {
    ...mapState({
      list: state => state.statistics.attachment.list,
      columns: state =>
        state.setting.settings.DECISION_REPORT_COLUMNS?.value &&
        JSON.parse(state.setting.settings.DECISION_REPORT_COLUMNS.value)
    }),

    procedureId() {
      return this.$route.params.procedureId;
    },

    csvUrl() {
      return config.csvURL + `/decision-report/${this.procedureId}`;
    },

    csvFields() {
      if (!this.$schema) {
        return [];
      }
      const data = this.$schema.$getData();
      if (!data) {
        return [];
      }
      return [{ name: 'filters', value: JSON.stringify({ filterFields: removeEmptyObjectFields(data) }) }];
    }
  },

  methods: {
    // @vuese
    // Nakłada filtry
    applyFilters() {
      this.saveSchemaQuery();
      getDecisionReport(this.$route).catch(err => this.notifyError(Errors.REPORT_CANNOT_GET));
    },

    // @vuese
    // Czyści filtry
    clearFilters() {
      this.$schema.$setDefault();
      this.applyFilters();
    },

    // @vuese
    // Zapisuje filtry do sessionStorage
    saveSchemaQuery() {
      const data = this.$schema.$getData();
      sessionStorage.setItem(Storage.REPORT_DECISION_FILTERS, JSON.stringify(data));
    }
  },

  beforeRouteUpdate(to, from, next) {
    getDecisionReport(to)
      .then(() => next())
      .catch(err => this.notifyError(Errors.REPORT_CANNOT_GET));
  }
};
</script>
